function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff8902;stroke:#ff8902;stroke-width:0.8px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-6.7 -6.7)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M18.77,7.1a11.67,11.67,0,1,0,11.67,11.67A11.642,11.642,0,0,0,18.77,7.1Zm0,22.075a10.4,10.4,0,1,1,10.4-10.4A10.442,10.442,0,0,1,18.77,29.175Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M37.537,23.48H31.912V17.856a.656.656,0,0,0-1.312,0v6.28a.641.641,0,0,0,.656.656h6.28a.656.656,0,1,0,0-1.312Z",
  transform: "translate(-12.486 -5.366)"
}));

var SvgClockIcon = function SvgClockIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.141,
    height: 24.141,
    viewBox: "0 0 24.141 24.141",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ClockIcon.2b7580a6.svg";
export { ForwardRef as ReactComponent };